
import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridTenantUsersSettings {

  constructor(private translate: TranslateService) { }

  public agGridTenantUsersSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 35,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { field: 'userName', headerName: `${this.translate.data["USERSUSERNAMECOLUMNHEADER"]}`, sortable: true, filter: true },
      { field: 'email', headerName: `${this.translate.data["USERSEMAILCOLUMNHEADER"]}`, sortable: false, filter: true },
      { field: 'phoneNumber', headerName: `${this.translate.data["USERSPHONENUMBERCOLUMNHEADER"]}`, sortable: true, filter: true },
    //   {
    //     headerName: `${this.translate.data["USERSACTIONSCOLUMNHEADER"]}`,
    //     cellRenderer: 'buttonRenderer',
    //     cellRendererParams: {
    //       icon_edit: 'edit',
    //       icon_delete: 'delete',
    //       routerLinkEditUser: (params: ICellRendererParams) => `/manage-users/${_.get(params, 'data.id')}/edit`
    //     },
    //   },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }

}